module.exports = __webpack_public_path__ + "static/media/snacks_image3.41a9b147.jpg";